var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99086 2.17268C6.48789 1.67565 6.48789 0.869804 5.99086 0.372773C5.49383 -0.124258 4.68799 -0.124258 4.19096 0.372773L0.372773 4.19095C0.25074 4.31299 0.158669 4.45364 0.09656 4.60376C0.0343404 4.75382 0 4.91835 0 5.09091C0 5.26348 0.0343453 5.42802 0.096573 5.57809C0.158506 5.72777 0.250226 5.86804 0.371735 5.98982C0.372111 5.9902 0.372487 5.99058 0.372864 5.99095L4.19096 9.80905C4.68799 10.3061 5.49383 10.3061 5.99086 9.80905C6.48789 9.31201 6.48789 8.50617 5.99086 8.00914L4.34536 6.36364H7.63636C9.74504 6.36364 11.4545 8.07314 11.4545 10.1818V12.7273C11.4545 13.4302 12.0244 14 12.7273 14C13.4302 14 14 13.4302 14 12.7273V10.1818C14 6.66733 11.1509 3.81818 7.63636 3.81818H4.34536L5.99086 2.17268Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteLeft);
export default __webpack_public_path__ + "static/media/icon-route-left.6e2f5c4ffaa4c474f9f1b2a52b1a787b.svg";
export { ForwardRef as ReactComponent };